export default __webpack_public_path__ + "static/media/about.853276f7.jpg";